import { render } from "./ModalManageSms.vue?vue&type=template&id=1cbffd9f"
import script from "./ModalManageSms.vue?vue&type=script&lang=js"
export * from "./ModalManageSms.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__